export default __webpack_public_path__ + "static/media/tagFaces.25165429.svg";